import ubuntLogo from "../../images/UbuntL.png";
import "./Support.css";

export default function Support() {
  return (
    <section className="schedule-page">
      <div className="schedule-inner">
        <h1 className="schedule-title">Support Us</h1>
        <p className="schedule-sub">
          Help Kgubetswana FM and Clarens Sportz Revive continue serving and uplifting the community.
        </p>

        <div className="support-intro">
          <p>
            Kgubetswana FM is more than just a radio station. It is a voice for the community, a platform
            for local stories, and a gathering point for culture, music, and conversation. Similarly,
            Clarens Sportz Revive exists to bring young people together through sport, giving them
            purpose, discipline, and a sense of belonging. Both organisations are rooted in the same
            mission: to strengthen the fabric of the Clarens and Kgubetswana communities by creating
            spaces where people can connect, grow, and thrive. But none of this is possible without your
            support. Whether you are a local business, a community member, or someone who simply believes
            in the power of grassroots initiatives, there are meaningful ways you can get involved and
            make a lasting difference.
          </p>
        </div>

        <div className="support-tournaments">
          <div className="support-section support-section-half">
            <h2 className="support-section-title">Annual Volleyball Tournaments</h2>
            <p>
              Twice a year, Clarens Sportz Revive organises a major volleyball tournament that brings
              together teams from across the region. These tournaments are not just about competition — they
              are about community. Young men and women who have been training week after week at the
              Kgubetswana Stadium get the chance to showcase their skills, compete against visiting teams,
              and experience the thrill of playing in a properly organised sporting event. The annual
              volleyball tournaments have become a highlight on the local calendar, drawing spectators,
              families, and supporters from all walks of life.
            </p>
            <p>
              The funds raised through these tournaments go directly towards supporting Clarens Impact, our
              men's volleyball team, as well as contributing to the wider operations of Kgubetswana FM. This
              includes covering costs such as equipment, jerseys, transport to away fixtures, venue hire,
              and the general overheads that keep the radio station on air. By attending, sponsoring, or
              volunteering at these tournaments, you are directly investing in the development of young
              athletes and the sustainability of a community institution that serves hundreds of listeners
              every single day.
            </p>
            <p>
              Each tournament is carefully organised to be a family-friendly event with music, food, and a
              festive atmosphere that reflects the spirit of Clarens Sportz Revive. Sponsors are given
              prominent branding opportunities, including banners, shout-outs on Kgubetswana FM, and
              recognition across our social media platforms on TikTok, Facebook, and YouTube. Whether you
              can contribute financially, donate prizes, or simply help spread the word, every bit of
              support helps us deliver a tournament that the community can be proud of.
            </p>
          </div>

          <div className="support-section support-section-half">
            <h2 className="support-section-title">Annual Netball Tournaments</h2>
            <p>
            Our netball programme is one of the cornerstones of Clarens Sportz Revive. With two active
            teams:
            <br /><strong>Clarens NetStars</strong> for U18 girls and <strong>Clarens Red Dragons</strong> 
            for U16 unisex players.
            <br/>
            We are nurturing the next generation of netball talent in Kgubetswana. The annual netball
            tournaments provide these young players with a competitive platform that goes beyond regular
            training sessions. For many of these players, these tournaments represent the first time they
            have played in a formal, well-organised competition, and the experience is one of a kind.
          </p>
          <p>
            The tournaments attract teams from neighbouring towns and communities, creating opportunities
            for cultural exchange, friendship, and healthy rivalries. But more importantly, they send a
            powerful message to young people in Kgubetswana: that sport matters, that their
            aspirations are valid, and that there are people and organisations willing to invest in their
            development. The netball tournaments also serve as a fundraising vehicle for KgubetswanaFM and the netball teams,
            with entry fees, spectator donations, and sponsor contributions all going towards keeping the
            station running and the teams equipped.
          </p>
          <p>
            The Clarens NetStars and Red Dragons give young girls a safe, structured, and 
            encouraging environment to develop not just their athletic abilities,
            but also leadership skills, teamwork, and self-confidence. These are qualities that extend
            far beyond the court and into schools, families, and future careers. If you are a business
            looking to make a meaningful social impact, or an individual who wants to champion the
            development of young women through sport, partnering with us on these tournaments is one of
            the most direct and rewarding ways to do so.
          </p>
          </div>
        </div>
        <div className="support-section">
          <h2 className="support-section-title">How You Can Help</h2>
          <p>
            There are many ways to support KgubetswanaFM and Clarens Sportz Revive, and every
            contribution, no matter how large or small, makes a real difference. Here are some of the
            key ways you can get involved:
          </p>
          <div className="support-options">
            <div className="support-option">
              <h3 className="support-option-title">Become a Tournament Sponsor</h3>
              <p>
                Sponsorship is the lifeblood of our annual tournaments. By becoming a sponsor, you
                help cover the costs of venue hire, equipment, prizes, transport, and organisation. In
                return, your brand receives exposure through mentions on Kgubetswana FM's live broadcasts, 
                and recognition across all of our social media channels.
              </p>
            </div>
            <div className="support-option">
              <h3 className="support-option-title">Donate Equipment or Prizes</h3>
              <p>
                Our teams are always in need of quality sporting equipment like netballs, volleyball, nets,
                training cones, jerseys, and first aid supplies. If you are a sports retailer, a
                manufacturer, or simply someone with surplus gear, donating equipment is a tangible way to
                support the development of young athletes. Similarly, donating prizes for tournament
                winners and participants helps create a sense of occasion and reward that motivates our
                players to give their best.
              </p>
            </div>
            <div className="support-option">
              <h3 className="support-option-title">Spread the Word</h3>
              <p>
                One of the simplest but most powerful ways to support us is by spreading the word.
                Share our social media posts, tell your friends and family about Kgubetswana FM and
                Clarens Sportz Revive, as well as encourage others to get involved. The more people who know about
                what we are doing, the more support we can attract the greater the impact we can have
                on the community.                 Follow us on <a href="https://www.tiktok.com/@csr2640" target="_blank" rel="noopener noreferrer">CSR's TikTok</a>, <a href="https://www.tiktok.com/@cuatro.bodroex" target="_blank" rel="noopener noreferrer">Quattro's TikTok</a>, <a href="https://www.facebook.com/quattro.pudro" target="_blank" rel="noopener noreferrer">Facebook</a>, and <a href="https://www.youtube.com/@ClarensSportzRevive2640" target="_blank" rel="noopener noreferrer">YouTube</a> to help us reach a wider
                audience.
              </p>
            </div>
            <div className="support-option">
              <h3 className="support-option-title">Make a Financial Contribution</h3>
              <p>
                If you would like to make a direct financial contribution to Kgubetswana FM or Clarens
                Sportz Revive, we welcome donations of any size. Every rand goes towards maintaining our equipment, 
                funding team operations, and ensuring that our tournaments continue to grow in quality and scale. 
                Financial support is particularly valuable because it gives us the flexibility to address the most 
                urgent needs as they arise, whether that is repairing a transmitter, buying new jerseys, or covering transport
                costs for any away match.
              </p>
            </div>
          </div>
        </div>

        <div className="support-section">
          <h2 className="support-section-title">Why Your Support Matters</h2>
          <p>
            The community radio and the communal sports are two of the most powerful tools for social change.
            They reach people where they are, speak to their lived experiences and create opportunities
            that might not otherwise exist. Clarens Sportz Revive gives young people an alternative to idle 
            time by channelling their energy into sport, teamwork, and personal growth. Kgubetswana FM allows us to
            communicate with the Community, spread good news and to inform regarding any new events or the like.
          </p>
          <p>
            However, sustaining these efforts requires ongoing support. Running sports teams involves expenses that most
            people never think about: balls that wear out, jerseys that need replacing, transport that
            must be arranged, and venues that must be hired. The annual tournaments are our primary
            fundraising mechanism, and they rely entirely on the generosity and goodwill of sponsors,
            donors, and supporters like you.
          </p>
          <p>
            When you support Kgubetswana FM and Clarens Sportz Revive, you are not just supporting an
            organisation, you are supporting a vision. A vision of a community where young people have
            purpose and opportunity, where local stories are told and celebrated, where music and sport
            bring people together, and where the spirit of <span className="support-gold">Re Mona Le Lona</span>, <span className="support-gold">Re Bina Le Lona</span>, <span className="support-gold">Re Bua Le Lona</span>
            is not just a tagline but a way of life. Your support makes this vision a reality, and we are deeply 
            grateful for every contribution.
          </p>
        </div>

        <div className="support-ubuntu">
          <img src={ubuntLogo} alt="Ubuntu Crew" className="support-ubuntu-img" />
          <div className="support-ubuntu-body">
            <p className="support-ubuntu-text">
              Your trusted local team for affordable, reliable home and property services.
              From professional cleaning and garden maintenance to small repairs and odd jobs,
              our dedicated crew is committed to keeping your home and community looking its best.
            </p>
            <p className="support-ubuntu-text">
              By choosing Clarens Ubuntu Crew, you are not only getting quality service at a
              fair price, you are also supporting local youth employment and helping build
              a stronger community.
            </p>
            <p className="support-ubuntu-cta">
              Get in touch with us today and let us take care of the rest.
            </p>
            <div className="support-ubuntu-contacts">
              <span className="support-ubuntu-contact">
                <span className="support-ubuntu-contact-label">Call:</span> 079 722 3037
              </span>
              <span className="support-ubuntu-contact">
                <span className="support-ubuntu-contact-label">WhatsApp:</span> 067 199 7121
              </span>
            </div>
          </div>
        </div>

        <div className="support-contact">
          <p>
            For sponsorship enquiries, donation arrangements, or to get involved in any other way, please
            contact Quattro Mokoena at <span className="support-gold">kgubestwanafm@gmail.com</span> or
            reach out to us on our social media pages.
          </p>
        </div>
      </div>
    </section>
  );
}
